// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".talent-name[data-v-23a032c4]{font-size:18px;font-weight:600}.recruitment-title[data-v-23a032c4]{font-size:16px;font-weight:400;color:#858585}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
